<template>
  <sc-render :fields="fields" :emptyMessage="$t('NO_DATA_SOURCE_EXIST')">
    <div :class="{'min-height': isEditMode}" class="carousel-gallery">
      <div class="carousel-card-wrapper">
        <carousel-card v-for="(image, index) in fields.images" :image="image.fields.image.value" :key="index" />
      </div>
      <div v-if="hasCredits(fields) || isEditMode" class="carousel-gallery__credit">
        <sc-rich-text tag="p" :field="fields.credit || {}"/>
        <sc-rich-text tag="p" :field="fields.collaboration || {}"/>
      </div>
    </div>
  </sc-render>
</template>

<script>

import { Image, RichText } from '@sitecore-jss/sitecore-jss-vue'
import { createNamespacedHelpers } from 'vuex'
import get from '~/helpers/get'
import isEmptyObject from '~/helpers/is-empty-object'
import ScRender from '../sc-render/'
import CarouselCard from '../carousel-card'

const { mapGetters: mapJssGetters } = createNamespacedHelpers('jss')

export default {
  name: 'CarouselGallery',

  props: {
    fields: {
      type: Object,
      default: () => ({})
    }
  },

  components: {
    ScRichText: RichText,
    ScImage: Image,
    ScRender,
    CarouselCard
  },

  computed: {
    ...mapJssGetters(['isEditMode']),

    isEmpty () {
      return isEmptyObject(this.fields)
    }
  },

  methods: {
    hasCredits () {
      return !!(get(this.fields, ['credit', 'value'])
        || get(this.fields, ['collaboration', 'value']))
    }
  }
}
</script>

<style lang="scss" scoped>

.carousel-gallery {
  width: 90%;
  margin-left: auto;
  margin-bottom: $space-080;

  @include tablet {
    margin-bottom: $space-090;
  }

  &.min-height {
    min-height: 200px;
  }
}

.carousel-card-wrapper{
  height: 100%;
  display: flex;
  overflow-x: scroll;
  -webkit-overflow-scrolling: touch;
}

.carousel-gallery__credit {
  @include font('070');

  font-style: italic;
  text-align: right;
  color: $color-slate-dark;
  padding-top: 10px;
  padding-right: 30px;

  @include desktop {
    padding-right: 100px;
  }

  p {
    margin: 0;

    @include desktop {
      margin: 5px 0;
    }
  }
}

</style>
